<template>
  <!-- <section class="grid-test">
    <div class="row">
      <div class="col-1-of-2">
        Col 1 of 2
      </div>
      <div class="col-1-of-2">
        Col 1 of 2
      </div>
    </div>
    <div class="row">
      <div class="col-1-of-3">
        Col 1 of 3
      </div>
      <div class="col-1-of-3">
        Col 1 of 3
      </div>
      <div class="col-1-of-3">
        Col 1 of 3
      </div>
    </div>
    <div class="row">
      <div class="col-1-of-3">
        Col 1 of 3
      </div>
      <div class="col-2-of-3">
        Col 2 of 3
      </div>
    </div>
    <div class="row">
      <div class="col-1-of-4">
        Col 1 of 4
      </div>
      <div class="col-1-of-4">
        Col 1 of 4
      </div>
      <div class="col-2-of-4">
        Col 2 of 4
      </div>
    </div>

    <div class="row">
      <div class="col-1-of-4">
        Col 1 of 4
      </div>
      <div class="col-3-of-4">
        Col 3 of 4
      </div>
    </div>
  </section> -->
  <main>
    <section class="section-about">
      <div class="u-text-center u-mb-8">
        <h2 class="heading-secondary">
          ¿Te gustaría viajar y vivir increíbles experiencias en México?
        </h2>
      </div>

      <div class="row">
        <div class="col-1-of-2">
          <h3 class="heading-tertitary u-mb-2">
            Llegaste a la comunidad de viajeros indicada ✈
          </h3>
          <p class="paragraph">
            ¡Conoce México es una empresa mexicana experta en viajes a los
            mejores destinos alternativos de México, creada con el objetivo de
            que conozcas nuevos lugares, vivas experiencias increíbles y te
            aventures a viajar por nuestro grandioso país!
          </p>
          <h3 class="heading-tertitary u-mb-2">
            Las mejores experiencias las vives con nosotros 🔥
          </h3>
          <p class="paragraph">
            ¡Tenemos los mejores tours para que viajes durante todo el año! Más
            de 20 destinos te esperan con nosotros, realizamos tours en grupo
            cada mes, viajes especiales de temporada y destinos fijos para que
            te vayas de viaje cuando tu elijas!
          </p>
          <a href="#" class="btn-text">Ver más 👉🏻</a>
        </div>
        <div class="col-1-of-2">
          <div class="composition">
  

            <img
              src="../assets/1x/image1.jpg"
              alt="Photo 1"
              class="composition__photo composition__photo--p1"
            />
            <img
              src="../assets/1x/image3.jpg"
              alt="Photo 3"
              class="composition__photo composition__photo--p2"
            />
            <img
              src="../assets/1x/image2.jpg"
              alt="Photo 2"
              class="composition__photo composition__photo--p3"
            />
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "firstSection",
};
</script>

<style></style>
